import React from 'react';
import { Button } from '@fupa/fupa-uikit';
import VotingStatus from 'app/components/match/bestPlayer/VotingStatus';
const VotingButton = _ref => {
  let {
    onClick,
    votingStatus,
    isFetching
  } = _ref;
  if (isFetching || votingStatus === VotingStatus.NotStarted) {
    return /*#__PURE__*/React.createElement(Button, {
      label: "Zur Abstimmung",
      disabled: true
    });
  }
  return /*#__PURE__*/React.createElement(Button, {
    label: votingStatus === VotingStatus.Completed ? 'Alle Stimmen' : 'Zur Abstimmung',
    onClick: onClick,
    "data-sentry-element": "Button",
    "data-sentry-component": "VotingButton",
    "data-sentry-source-file": "VotingButton.tsx"
  });
};
export default VotingButton;